import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import Loader from 'components/Loader';

type ModalLoaderProps = {
  open: boolean;
  close: () => void;
};

const ModalLoader = ({ open, close }: ModalLoaderProps): JSX.Element => {
  return (
    <Modal closeOnOverlayClick={false} isOpen={open} onClose={close}>
      <ModalOverlay />
      <ModalContent
        alignSelf="center"
        width={['100%', '80%', '60%', '50%']}
        my={0}
        borderRadius={0}
        background="transparent"
        boxShadow="none"
      >
        <ModalBody>
          <Loader color="custom.levoBlue" />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalLoader;
